import { apiGet } from '../_common';

export default {
  getDiscountById(id) {
    return apiGet(`/magenta/billing/discount/${id}`)
      .then(result => result.response);
  },
};
